export type SettingsSection = 'company' | 'attendance' | 'public-page';
export type SettingsTabId =
  'company' | 'address' | 'operation' | 'hours' | 'presentation' | 'public-info' | 'visibility';

type SettingsSectionConfig = {
  title: string;
  description: string;
  tabs: { id: SettingsTabId; label: string; description: string }[];
};
export const SETTINGS_SECTIONS: Record<SettingsSection, SettingsSectionConfig> = {
  company: {
    title: 'Empresa',
    description: 'Gerencie o cadastro e o endereço da empresa.',
    tabs: [
      { id: 'company', label: 'Dados gerais', description: 'Nome, documento e contato' },
      { id: 'address', label: 'Endereço', description: 'Localização e mapa' },
    ],
  },
  attendance: {
    title: 'Atendimento',
    description: 'Configure a operação, as regras de agendamento e os horários.',
    tabs: [
      { id: 'operation', label: 'Operação', description: 'Agenda, fila e confirmações' },
      { id: 'hours', label: 'Horários', description: 'Dias de atendimento e intervalos' },
    ],
  },
  'public-page': {
    title: 'Página pública',
    description: 'Organize o conteúdo e a visibilidade da sua empresa para os clientes.',
    tabs: [
      { id: 'presentation', label: 'Apresentação', description: 'Link, descrição e imagens' },
      { id: 'public-info', label: 'Contatos e detalhes', description: 'Redes, comodidades e pagamentos' },
      { id: 'visibility', label: 'Visibilidade', description: 'Página pública e busca' },
    ],
  },
};

export function resolveSettingsLocation(params: URLSearchParams): { section: SettingsSection; tab: SettingsTabId } {
  const requestedSection = params.get('section');
  const requestedTab = params.get('tab');
  const section: SettingsSection =
    requestedSection === 'attendance' || requestedSection === 'public-page' || requestedSection === 'company'
      ? requestedSection
      : requestedTab === 'operation'
        ? 'attendance'
        : 'company';
  const legacyTab = section === 'public-page' && requestedTab === 'operation' ? 'visibility' : requestedTab;
  return {
    section,
    tab:
      SETTINGS_SECTIONS[section].tabs.find((tab) => tab.id === legacyTab)?.id ?? SETTINGS_SECTIONS[section].tabs[0].id,
  };
}
